import { IS_PROD_ENV } from '../_services/const.js';

const WebConfig = {
    DEV: {
        logout_timer: 1,
        odc_enabled: [2285, 16214]
    },
    PROD: {
        logout_timer: 10,
        odc_enabled: [2672746, 3306463]
    }
};
const getWebConfig = () => {
    return IS_PROD_ENV ? WebConfig["PROD"] : WebConfig["DEV"];
};

export { getWebConfig };
//# sourceMappingURL=web-config.js.map
